import { useCallback, useState } from 'react';

import type { DownloadWithToastOptions } from '~/utils/download-with-toast';
import { downloadWithToast } from '~/utils/download-with-toast';

/**
 * Drive one or more authenticated file downloads through the shared download
 * toast, tracking which one is in flight so the triggering button can show a
 * spinner. Errors are reported by the toast (with a Retry action), so there is
 * deliberately no error state here to surface a second time.
 */
export function useFileDownload() {
  const [pendingKey, setPendingKey] = useState<string | null>(null);

  const start = useCallback((options: DownloadWithToastOptions) => {
    setPendingKey(options.key);
    void downloadWithToast(options).finally(() => {
      setPendingKey(null);
    });
  }, []);

  /** True while `key`'s download is in flight — bind to the button's `isLoading`. */
  const isDownloading = useCallback((key: string) => pendingKey === key, [pendingKey]);

  return { start, pendingKey, isDownloading };
}
